import Image from "next/image";
import { MdAccountCircle } from "react-icons/md";
import Button from "./common/Button";
import HamburgerMenus from "./common/HamburgerMenus";
import React from "react";

const TopHead: React.FC = () => {
  return (
    <div className="p-3 bg-slate-50/15 backdrop-blur flexer py-4 fixed w-screen z-20">
      <div className="container flex justify-between items-center px-4">
        <Image src="/Images/Logo.png" alt="loading" width={200} height={200} />
  
        <ul className="hidden lg:flexer gap-4">
          <Button
            className=" !bg-transparent text-slate-800 hover:font-semibold"
            name="Promote music"
            path="/"
          />
          <Button
            className=" !bg-transparent text-slate-800 hover:font-semibold"
            name="Events"
            path="/events"
            // path="/"
          />
          <Button
            className=" !bg-transparent text-slate-800 hover:font-semibold"
            name="About us"
            path="/about"
            // path="/"
          />
          <Button
            icon={<MdAccountCircle />}
            className="bg-slate-200 text-slate-800"
            name="Sign in"
            // path="/"
            path="/auth"
          />
          <Button
            icon={<MdAccountCircle />}
            className="!bg-orange-600 text-white"
            name="Dashboard"
          />
        </ul>
        <div className="block lg:hidden">
          <HamburgerMenus />
        </div>
      </div>
    </div>
  );
};
export default TopHead;
